module.exports = "/assets/sign_marker-01c66f6f5836d7563c5d453937ccf201.svg";